module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAA0ElEQVR42u2TMQqDQBRERwtbkcAewX4LC5u04gU8gGiKgBAEwYPkAB5AL6DpkkCqFOlyGjMErP8mCkLI8JCZz/4pVsVfnyoIAmH4tYqi0FrbQK0UoWHkEPPleV5VVSlwjyJCw8ghRI0GOrftyXGeZUloGE22MEDm+H4+koRMUcTsUAT0wNX3Sc+4YPUGaICb1qRhXKN6/QuZ/xpHA126bpg+PhpGky1gJ5EjPsSpnn4ZDUbk8qJ8ItyHbubaOeqtIjSMHC5QbWWWMBSqZ/Bb1S+MtYAoF7oOBAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/ke.png
// module id = 850
// module chunks = 0